// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3ddVQ","info":"PatientInfo_info__1nK4O"};